/** Placeholders supported in lender default_body and rich defaults. */
export type LenderSubmissionEmailContext = {
  company_name: string;
  tier_name: string;
  requested_amount: string;
  equipment_summary: string;
};

const PLACEHOLDER_RE = /\{(company_name|tier_name|requested_amount|equipment_summary)\}/g;

export function buildLenderSubmissionEmailContext(params: {
  companyName?: string | null;
  tierName?: string | null;
  requestedAmount?: string | number | null;
  equipmentSummary?: string | null;
}): LenderSubmissionEmailContext {
  const company_name = (params.companyName ?? "").trim() || "N/A";
  const tier_name = (params.tierName ?? "").trim() || "—";
  const equipment_summary = (params.equipmentSummary ?? "").trim() || "—";
  let requested_amount = "—";
  if (params.requestedAmount != null && params.requestedAmount !== "") {
    const n = Number(params.requestedAmount);
    requested_amount = Number.isFinite(n)
      ? `$${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      : String(params.requestedAmount);
  }
  return { company_name, tier_name, requested_amount, equipment_summary };
}

export function applyLenderSubmissionEmailPlaceholders(template: string, ctx: LenderSubmissionEmailContext): string {
  return template.replace(PLACEHOLDER_RE, (_, key: keyof LenderSubmissionEmailContext) => ctx[key] ?? "");
}

/** Default when lender has no body or empty body — matches backend Lender.default_body direction. */
export const RICH_LENDER_SUBMISSION_EMAIL_DEFAULT = `Dear Lender,

Please find attached our credit application for your review.

Company: {company_name}
Equipment: {equipment_summary}
Requested financing amount: {requested_amount}
Selected program / tier: {tier_name}

Thank you for your consideration.`;
